import {
  ACCOUNT_PAGE_LOADED,
  ACCOUNT_NEXT_PAGE_LOADED,
  ACCOUNT_PAGE_UNLOADED,
  ACCOUNT_WALLET_EXPORT,
  MASTER_ACCOUNT_LIST_PAGE_LOADED,
  MASTER_ACCOUNT_LIST_PAGE_UNLOADED,
  MASTER_ACCOUNT_CREATE,
  MASTER_ACCOUNT_CREATE_UNLOADED,
  MASTER_ACCOUNT_UPDATE,
  MASTER_ACCOUNT_UPDATE_UNLOADED,
  MASTER_ACCOUNT_UPDATE_LOADED,
  MASTER_ACCOUNT_DETAIL_LOADED,
  MASTER_ACCOUNT_DETAIL_UNLOADED,
  DEPOSIT_BANK_REFERENCE_CODE_SUBMIT,
  DEPOSIT_BANK_REFERENCE_CODE_UNLOAD,
  ACCOUNT_RESET_SYNCTIME,
  ACCOUNT_SEARCH,
  ACCOUNT_RAW_PAGE_LOADED,
  ACCOUNT_RAW_PAGE_UNLOADED,
  ACCOUNT_CREATE_PAGE_LOADED,
  ACCOUNT_CREATE,
  ACCOUNT_CREATE_PAGE_UNLOADED,
  MASTER_ACCOUNT_MINT_LOADED,
  MASTER_ACCOUNT_MINT,
  MASTER_ACCOUNT_MINT_UNLOADED
} from '../constants/actionTypes';
import { PAGESIZE } from '../constants/config'

export default (state = {}, action) => {
  switch (action.type) {
    case ACCOUNT_PAGE_LOADED:
    case ACCOUNT_RAW_PAGE_LOADED:
    case ACCOUNT_NEXT_PAGE_LOADED:
    case MASTER_ACCOUNT_DETAIL_LOADED:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        account: action.payload.account,
        totalCount: action.payload.account ? action.payload.account.totalCount : 0,
        currentPage: action.currentPage,
        totalPage: Math.ceil((action.payload.account ? action.payload.account.totalCount : 0) / PAGESIZE),
        csvData: null,
      };
    case MASTER_ACCOUNT_LIST_PAGE_LOADED:
      return {
        ...state,
        accounts: action.payload
      }
    case MASTER_ACCOUNT_CREATE:
    case MASTER_ACCOUNT_UPDATE:
    case ACCOUNT_RESET_SYNCTIME:
    case MASTER_ACCOUNT_MINT:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload.error : null,
      };
    case MASTER_ACCOUNT_UPDATE_LOADED:
    case MASTER_ACCOUNT_MINT_LOADED:
      return {
        ...state,
        account: action.payload
      }
    case DEPOSIT_BANK_REFERENCE_CODE_SUBMIT:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        amount: action.error ? null : action.payload ? action.payload.amount : null,
        success: action.payload.amount ? true : false,
      }
    case ACCOUNT_PAGE_UNLOADED:
    case MASTER_ACCOUNT_LIST_PAGE_UNLOADED:
    case MASTER_ACCOUNT_CREATE_UNLOADED:
    case MASTER_ACCOUNT_UPDATE_UNLOADED:
    case MASTER_ACCOUNT_DETAIL_UNLOADED:
    case DEPOSIT_BANK_REFERENCE_CODE_UNLOAD:
    case ACCOUNT_RAW_PAGE_UNLOADED:
    case ACCOUNT_CREATE_PAGE_UNLOADED:
    case MASTER_ACCOUNT_MINT_UNLOADED:
      return {};
    case ACCOUNT_WALLET_EXPORT:
      return {
        ...state,
        csvData: action.payload
      }
    case ACCOUNT_SEARCH:
      return {
        ...state,
        account: action.payload.account
      }
    case ACCOUNT_CREATE_PAGE_LOADED:
      return {
        ...state,
        accounts: action.payload.accounts
      }

    case ACCOUNT_CREATE:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload.error : null,
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/account.js